import React from "react";
import PropTypes from "prop-types";
import { Image } from "react-bootstrap";

import { getFehlertext } from "../model/Fehlertexte";

import "./ErrorDisplay.css";

const errorsFromProps = props => {
	let errors = [];
	props.errors.forEach(obj => {
		if (obj.cindex === props.component) {
			for (let prop in obj.errors) {
				if (obj.errors[prop]) {
					errors.push(parseInt(prop, 10));
				}
			}
		}
	});
	return errors;
};

const nextError = (index, num_errors) => (
	num_errors ? ((index + 1) % num_errors) : 0
);

class ErrorDisplay extends React.Component {

	static propTypes = {
		component: PropTypes.number.isRequired,
		errors: PropTypes.arrayOf(PropTypes.object).isRequired,
		fehlertexte: PropTypes.object.isRequired,
		locale: PropTypes.string.isRequired
	};

	constructor(props, context) {
		super(props, context);
		this.state = {
			errors: errorsFromProps(props),
			displayed_error: 0
		};
		this.timeout = null;
	}
	startTimer(length) {
		if (this.timeout) {
			clearInterval(this.timeout);
			this.timeout = null;
		}
		if (length) {
			let self = this;
			this.timeout = setInterval(() => {
				let num_errors = self.state.errors.length;
				let next_error = nextError(self.state.displayed_error, num_errors);
				self.setState({ displayed_error: next_error });
			}, 3000);
		}
	}
	componentDidMount() {
		this.startTimer(this.state.errors.length);
	}
	componentWillUnmount() {
		this.startTimer(0);
	}
	componentWillReceiveProps(nextProps) {
		let new_errors = errorsFromProps(nextProps);
		let new_state = {
			errors: new_errors,
			displayed_error: nextError(this.state.displayed_error - 1, new_errors.length)
		};
		this.setState(new_state);
		this.startTimer(new_errors.length);
	}
	render() {
		let { component, fehlertexte, locale } = this.props;
		let { displayed_error, errors } = this.state;
		return errors.length ? (
			<div className="almig-error-display">
				<Image src="/symwerkzeug56x56.png" className="wrench" />
				<span>
					{getFehlertext(component, errors[displayed_error], fehlertexte, locale)}
				</span>
			</div>
		) : null;
	}
}

export default ErrorDisplay;
